// This file is used for storing all data related to properties of charts that
// will result in rerender of the chart

import update from 'immutability-helper';
import Logger from '../../Logger';
import { initializeAxisOptions } from './constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// function removeTagFromHTMLString(htmlString: any, tagName: any, id: string) {
// 	// Create a new DOMParser instance
// 	const parser = new DOMParser();

// 	// Parse the HTML string
// 	const doc = parser.parseFromString(htmlString, "text/html");

// 	// Find all the elements with the specified tag name
// 	var element = doc.getElementById(id);

// 	if (element) {
// 		element.remove();
// 	}

// 	// Serialize the modified DOM back to an HTML string
// 	const modifiedHTMLString = new XMLSerializer().serializeToString(doc);

// 	return modifiedHTMLString;
// }

const chartControl = {
  properties: {
    1.1: {
      // SetNameWithAgg:"",
      chartErrorDetails: null,
      serverData: '',
      chartData: '',
      queryResult: '',
      sortOrder: '',
      //Earlier we were storing name but now we are storing id of selected field in sortedValue
      sortedValue: '',
      sortConfigurations: [],
      measureValue: { value: '', id: 'RichTextID' },
      showHide: {
        operator: '> Greater than',
        numberInput: '',
        dataType: '',
        funcNum: 'Numb',
        showNum: true,
        measureName: '',
        isShow: true,
      },
      rowSecurity: {
        currentOperator: 'User',
        filterPanels: {
          user: {
            filters: [],
            panelName: 'rowLevelSecurityFilters',
            shouldAllConditionsMatch: true,
          },
          group: {
            filters: [],
            panelName: 'rowLevelSecurityFilters',
            shouldAllConditionsMatch: true,
          },
        },
      },
      columnSecurity: {
        currentOperator: 'User',
        filterPanels: {
          user: {
            filters: [],
            panelName: 'columnLevelSecurityFilters',
            shouldAllConditionsMatch: true,
          },
          group: {
            filters: [],
            panelName: 'columnLevelSecurityFilters',
            shouldAllConditionsMatch: true,
          },
        },
      },
      richText: {
        text: [
          {
            type: 'p',
            children: [
              {
                text: 'Enter some text...',
                fontFamily: 'sans',
                fontSize: '12px',
                color: 'black',
              },
            ],
          },
        ],
        style: null,
        manualColor: false,
      },
      waterfall: { total: { isEnable: true, isRight: true, name: 'Grand Total' } },
      colorScheme: '',
      themeId: '',
      areaBackgroundColor: '#2BB9BB',
      areaOpacity: 0.1,

      colorScale: {
        colorScaleType: 'Automatic',
        min: 0,
        max: 0,
        minColor: '#2bb9bb',
        maxColor: '#af99db',
        manualColor: true,
      },

      legendOptions: {
        showLegend: true,
        moveSlider: 'Width',
        symbolWidth: 20,
        symbolHeight: 20,
        itemGap: 10,
        position: { pos: 'Bottom', top: 'bottom', left: 'center' },
        orientation: 'horizontal',
        top: '90%',
        left: '40%',
      },

      chartMargin: {
        //for pie
        radius: 70,
        // for gauge
        gaugeRadius: 100,
        // for donut and rose
        innerRadius: 30,
        outerRadius: 70,
        // for funnel chart
        funnelRight: 10,
        funnelLeft: 10,
        // for horizontal charts left
        horizontalLeft: 10,
        // for others
        selectedMargin: 'top',
        top: 5,
        right: 5,
        bottom: 5,
        left: 5,
      },

      cardControls: {
        height: 200,
        width: 350,
        generateLabelName: 'Auto',
        fontSize: 35,
        subtextFontSize: 15,
        isDragging: false,
        mainTextPos: { x: 129, y: 60 },
        subTextPos: { x: 126, y: 110 },
        subText: '',
        borderTickness: 2,
        borderRadius: 10,
        borderColor: 'rgba(224,224,224,1)',
        dashStyle: 'solid',
        fontStyle: 'normal',
        customStyle: false,
        valueColor: '#2BB9BB',
        labelColor: 'gray',
        bgColor: 'white',
        manualColor: false,
      },
      wordCloudOptions: {
        shape: 'square',
        rotationMode: 'horizontal',
        gridSize: 8,
        minFontSize: 12,
        maxFontSize: 40,
        drawOutOfBound: false,
        ignoreWords: [],
      },
      calendarStyleOptions: {
        showSplitLine: true,
        splitLineColor: 'black',
        splitLineWidth: 1,
        splitLineType: 'solid',
        showDayLabel: true,
        firstDay: 0,
        dayLabelMargin: 5,
        dayLabelPosition: 'start',
        dayLabelColor: '',
        dayLabelFontSize: 10,
        dayLabelBackground: false,
        dayLabelBackgroundColor: '#E9E9E9',
        showMonthLabel: true,
        monthLabelMargin: 5,
        monthLabelPosition: 'start',
        monthLabelColor: '',
        monthLabelFontSize: 12,
        monthLabelBackground: false,
        monthLabelBackgroundColor: '#E9E9E9',
        showYearLabel: true,
        yearLabelMargin: 24,
        yearLabelPosition: 'left',
        yearLabelColor: '',
        yearLabelFontSize: 12,
        yearLabelBackground: false,
        yearLabelBackgroundColor: '#E9E9E9',
        calendarGap: 30,
        calendarHeight: 10,
        pieceWise: false,
        height: 25,
        width: 80,
        orientation: 'horizontal',
      },
      lineChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      areaChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      stackedAreaChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      pieChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      doughnutChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      roseChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      scatterPlotChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
        opacity: 50,
        enableBubbleBorder: false,
        bubbleSize: 20,
        bubbleBorderWidth: 2,
      },
      funnelChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      barChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      horizontalStackedBarChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      horizontalBarChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      stackedBarChartControls: {
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      waterfallChartControls: {
        manualColor: false,
        positiveColor: '',
        negativeColor: '',
        totalColor: '',
        nodeValuesColors: {},
        allSeriesColor: '',
      },
      boxPlotChartControls: {
        colorBy: 'series', // or data,
        minBoxWidth: 10, // px or %,
        maxBoxWidth: 30,
        boxborderWidth: '2', //px
        flipAxis: false,
      },

      geoChartControls: {
        boderWidth: 1,
        borderColor: 'grey',
        mapZoom: 1,
        maxBubbleSize: 25, //50
        minBubbleSize: 12, //20
        areaColor: 'rgba(255,255,255,1)',
        emphasisAreaColor: 'yellow',
        aspectScale: 1,
        enableSelfEmphasis: false,
        minValue: '0',
        minColor: '#af99dbff',
        maxValue: '100',
        maxColor: '#2BB9BB',
        showVisualScale: true,
        manualColor: false,
        bgCol: {},
        isDivergentModeEnabled: true,
        isDivergentFormat: 'Abbrev',
        opacity: 70,
        enableBubbleBorder: false,
        bubbleBorderWidth: 2,
        divergentFormatValue: 'Number',
        enableRounding: false,
        roundingDigits: 1,
        currencySymbol: '$',
        percentType: 'NonCalculated',
      },

      treeMapChartControls: {
        treeMapWidth: 80, //%
        treeMapHeight: 80, //%
        leafDepth: 1,
        labelPosition: 'insideTopLeft',
        labelRotate: 0, //dropDown hori,verti,vertiflip
        horizondalAlign: 'right',
        verticleAlign: 'bottom',
        overFlow: 'truncate',
        borderWidth: 0,
        gapWidth: 2,
        showBreadCrumb: true,
        bcHeight: 22,
        bcWidth: 25,
        bcColor: 'rgba(0,0,0,0.7)',
        manualColor: false,
        nodesAndColors: [],
        nodeValuesColors: {},
        allSeriesColor: '',
      },

      sankeyControls: {
        nodeWidth: 10,
        nodeGap: 8,
        nodeAlign: 'justify',
        orient: 'horizontal',
        draggable: true,
        labelDistance: 5,
        labelRotate: 0,
        overFlow: 'truncate',

        labelPosition: 'inside',
        opacity: 20,
        curveness: 50,
        nodeColor: '#f589b8',
        linkColor: 'grey',
        nodesAndColors: [],
        backgroundColor: '#fff',
        manualColor: false,
      },

      crossTabStyleOptions: {
        borderWidth: 1,
        lineHeight: 18,
        lineWidth: 80,
        rowHeaderTextAlign: 'left',
        columnHeaderTextAlign: 'center',
        cellTextAlign: 'right',
      },
      crossTabHeaderLabelOptions: {
        labelColorManual: false,
        labelColor: '#666666',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeigth: 'normal',
        fontFamily: 'sans-serif',
        fontWeight: '500',
      },
      crossTabCellLabelOptions: {
        labelColorManual: false,
        labelColor: '#666666',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeigth: 'normal',
        fontFamily: 'sans-serif',
        fontWeight: '400',
      },

      labelOptions: {
        showLabel: true,
        showStateLabel: true,
        stateCheckBox: false,
        labelColor: '',
        pieLabel: {
          labelPosition: 'outside',
          labelPadding: 0,
        },
        fontSize: 12,
        fontStyle: 'normal',
        fontWeigth: 'normal',
        fontFamily: 'sans-serif',
        labelBackground: false,
        labelBackgroundColor: '',
      },

      formatOptions: {
        labelFormats: {
          formatValue: 'Number',
          currencySymbol: '$',
          enableRounding: 'false',
          roundingDigits: 1,
          numberSeparator: 'Abbrev',
          selectedMeasure: {},
          // measureFormats will keep the format options for the measure selected in the chart for individual measure
          measureFormats: {},
        },

        yAxisFormats: {
          1: {
            formatValue: 'Number',
            currencySymbol: '$',
            enableRounding: true,
            roundingDigits: 1,
            numberSeparator: 'Abbrev',
            percentageCalculate: false,
          },
        },

        xAxisFormats: {
          1: {
            formatValue: 'Number',
            currencySymbol: '$',
            enableRounding: true,
            roundingDigits: 1,
            numberSeparator: 'Abbrev',
            percentageCalculate: false,
          },
        },

        tooltipFormats: {
          isEnable: true,
          formatValue: 'Number',
          currencySymbol: '$',
          enableRounding: 'false',
          roundingDigits: 1,
          numberSeparator: 'Abbrev',
          checkedMeasure: [],
          extraMeasureField: [{ name: 'Measure', fields: [] }],
          extraMeasureFieldsResponses: [],
          selectedMeasure: {},
          measureFormats: {},
        },

        gaugeChartFormats: {
          measureFormat: {
            formatValue: 'Number',
            currencySymbol: '$',
            enableRounding: 'false',
            roundingDigits: 1,
            numberSeparator: 'Abbrev',
            percentageCalculate: false,
          },
          labelFormat: {
            formatValue: 'Number',
            currencySymbol: '$',
            enableRounding: 'false',
            roundingDigits: 0,
            numberSeparator: 'Abbrev',
            percentageCalculate: false,
          },
        },
      },

      mouseOver: {
        enable: true,
      },

      smoothCurve: {
        enable: true,
      },

      barLineSettings: {
        lineMeasures: [],
        barMeasures: [],
      },

      layoutOptions: {
        tableLayout: 'shrinked',
        manualWidth: false,
        manualHeight: false,
        customWidth: {},
        customHeight: {},
      },

      axisOptions: {
        xSplitLine: true,
        ySplitLine: true,
        inverse: false,
        gaugeAxisOptions: {
          startAngle: 225,
          endAngle: -45,
          showTick: true,
          tickSize: 5,
          tickPadding: 12,
          showAxisLabel: true,
          labelPadding: 17,
          min: 0,
          max: 0,
          isMaxAuto: true,
        },

        gaugeChartControls: {
          manualColor: false,
          isStepsAuto: true,

          stepcolor: [
            {
              color: '#2bb9bb',
              per: 0.6,
              isColorAuto: false,
              stepValue: 60,
              value: 100,
            },
            {
              color: '#af99db',
              per: 0.9,
              isColorAuto: false,
              stepValue: 30,
              value: 100,
            },
            {
              color: '#5ab1ef',
              per: 1,
              isColorAuto: false,
              stepValue: 10,
              value: 100,
            },
          ],
        },
        pieAxisOptions: {
          pieStartAngle: 90,
          clockWise: true,
        },
        yAxis: {
          1: initializeAxisOptions('y'),
        },
        xAxis: {
          1: initializeAxisOptions('x'),
        },
        scatterChartMinMax: {
          x_enableMin: false,
          x_minValue: 0,
          x_enableMax: false,
          x_maxValue: 10000,
          y_enableMin: false,
          y_minValue: 0,
          y_enableMax: false,
          y_maxValue: 10000,
        },

        axisMinMax: {
          enableMin: false,
          minValue: 0,
          enableMax: false,
          maxValue: 10000,
        },
      },

      // note : not used these values yet, these are created for table chart conditional format, can remove in future if not needed
      tableLabel: [],
      tableGradient: [],
      tableRule: [],

      tableConditionalFormats: [],
      simplecardConditionalFormats: [],
    },
  },

  propList: { 1: ['1.1'] },
};

const chartControlsReducer = (state: any = chartControl, action: any) => {
  switch (action.type) {
    case 'ADD_NEW_CONTROL':
      let tileKey = `${action.payload.tabId}.${action.payload.tileId}`;
      return {
        properties: {
          ...state.properties,
          [tileKey]: {
            chartErrorDetails: null,
            chartData: '',
            queryResult: '',
            sortOrder: '',
            sortedValue: '',
            sortConfigurations: [],
            measureValue: { value: '', id: 'RichTextID' },
            showHide: {
              operator: '> Greater than',
              numberInput: '',
              dataType: '',
              funcNum: 'Numb',
              showNum: true,
              measureName: '',
              isShow: true,
            },
            rowSecurity: {
              currentOperator: 'User',
              filterPanels: {
                user: {
                  filters: [],
                  panelName: 'rowLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
                group: {
                  filters: [],
                  panelName: 'rowLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
              },
            },
            columnSecurity: {
              currentOperator: 'User',
              filterPanels: {
                user: {
                  filters: [],
                  panelName: 'columnLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
                group: {
                  filters: [],
                  panelName: 'columnLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
              },
            },
            richText: {
              text: [
                {
                  type: 'p',
                  children: [{ text: 'Enter some text...' }],
                },
              ],
              style: null,
              manualColor: false,
            },
            waterfall: { total: { isEnable: true, isRight: true, name: 'Grand Total' } },
            colorScheme: '',
            themeId: '',
            areaBackgroundColor: '#2BB9BB',
            areaOpacity: 0.1,

            colorScale: {
              colorScaleType: 'Automatic',
              min: 0,
              max: 0,
              minColor: '#2bb9bb',
              maxColor: '#af99db',
              manualColor: false,
            },

            legendOptions: {
              showLegend: true,
              moveSlider: 'Width',
              symbolWidth: 20,
              symbolHeight: 20,
              itemGap: 10,
              position: { pos: 'Bottom', top: 'bottom', left: 'center' },
              orientation: 'horizontal',
            },

            chartMargin: {
              //for pie
              radius: 70,
              //for gauge
              gaugeRadius: 100,
              // for donut and rose
              innerRadius: 30,
              outerRadius: 70,
              // for funnel chart
              funnelRight: 10,
              funnelLeft: 10,
              // for horizontal charts left
              horizontalLeft: 10,
              // for others
              selectedMargin: 'top',
              top: 5,
              right: 5,
              bottom: 5,
              left: 5,
            },
            cardControls: {
              height: 200,
              width: 350,
              generateLabelName: 'Auto',
              fontSize: 35,
              subtextFontSize: 15,
              isDragging: false,
              mainTextPos: { x: 129, y: 60 },
              subTextPos: { x: 126, y: 110 },
              subText: '',
              borderTickness: 2,
              borderRadius: 10,
              borderColor: 'rgba(224,224,224,1)',
              dashStyle: 'solid',
              fontStyle: 'normal',
              customStyle: false,
              valueColor: '#2BB9BB',
              labelColor: 'gray',
              bgColor: 'white',
              manualColor: false,
            },
            wordCloudOptions: {
              shape: 'square',
              rotationMode: 'horizontal',
              gridSize: 8,
              minFontSize: 12,
              maxFontSize: 40,
              drawOutOfBound: false,
              ignoreWords: [],
            },

            calendarStyleOptions: {
              showSplitLine: true,
              splitLineColor: 'black',
              splitLineWidth: 1,
              splitLineType: 'solid',
              showDayLabel: true,
              firstDay: 0,
              dayLabelMargin: 5,
              dayLabelPosition: 'start',
              dayLabelColor: 'black',
              dayLabelFontSize: 10,
              showMonthLabel: true,
              monthLabelMargin: 5,
              monthLabelPosition: 'start',
              monthLabelColor: 'black',
              monthLabelFontSize: 12,
              showYearLabel: true,
              yearLabelMargin: 24,
              yearLabelPosition: 'left',
              yearLabelColor: 'black',
              yearLabelFontSize: 12,
              calendarGap: 30,
              calendarHeight: 10,
              pieceWise: false,
              height: 25,
              width: 80,
              orientation: 'horizontal',
            },
            lineChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            areaChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            stackedAreaChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            pieChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            doughnutChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            roseChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            scatterPlotChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
              opacity: 50,
              enableBubbleBorder: false,
              bubbleSize: 20,
              bubbleBorderWidth: 2,
            },
            funnelChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            barChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            horizontalStackedBarChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            horizontalBarChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            stackedBarChartControls: {
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            waterfallChartControls: {
              manualColor: false,
              positiveColor: '',
              negativeColor: '',
              totalColor: '',
              nodeValuesColors: {},
              allSeriesColor: '',
            },
            boxPlotChartControls: {
              colorBy: 'series', // or data,
              minBoxWidth: 10, // px or %,
              maxBoxWidth: 30,
              boxborderWidth: '2', //px
              flipAxis: false,
            },

            geoChartControls: {
              boderWidth: 1,
              borderColor: 'grey',
              mapZoom: 1,
              maxBubbleSize: 25,
              minBubbleSize: 12,
              areaColor: 'rgba(255,255,255,1)',
              emphasisAreaColor: 'yellow',
              aspectScale: 1,
              enableSelfEmphasis: true,
              minValue: '0',
              minColor: '#AF99DB',
              maxValue: '100',
              maxColor: '#2BB9BB',
              showVisualScale: true,
              manualColor: false,
              bgCol: {},
              isDivergentModeEnabled: true,
              isDivergentFormat: 'Abbrev',
              opacity: 70,
              enableBubbleBorder: false,
              bubbleBorderWidth: 2,
              divergentFormatValue: 'Number',
              enableRounding: false,
              roundingDigits: 1,
              currencySymbol: '$',
              percentType: 'NonCalculated',
            },

            treeMapChartControls: {
              treeMapWidth: 80, //%
              treeMapHeight: 80, //%
              leafDepth: 1,
              labelPosition: 'insideTopLeft',
              labelRotate: 0, //dropDown hori,verti,vertiflip
              horizondalAlign: 'right',
              verticleAlign: 'bottom',
              overFlow: 'truncate',
              borderWidth: 0,
              gapWidth: 2,
              showBreadCrumb: true,
              bcHeight: 22,
              bcWidth: 25,
              bcColor: 'rgba(0,0,0,0.7)',
              manualColor: false,
              nodesAndColors: [],
              nodeValuesColors: {},
              allSeriesColor: '',
            },

            sankeyControls: {
              nodeWidth: 10,
              nodeGap: 8,
              nodeAlign: 'justify',
              orient: 'horizontal',
              draggable: true,
              labelDistance: 5,
              labelRotate: 0,
              overFlow: 'truncate',

              labelPosition: 'inside',
              opacity: 20,
              curveness: 50,
              nodeColor: '#f589b8',
              linkColor: 'grey',
              nodesAndColors: [],
              backgroundColor: '#fff',
              manualColor: false,
            },

            crossTabStyleOptions: {
              borderWidth: 1,
              lineHeight: 18,
              lineWidth: 80,
              rowHeaderTextAlign: 'left',
              columnHeaderTextAlign: 'center',
              cellTextAlign: 'right',
            },
            crossTabHeaderLabelOptions: {
              labelColorManual: false,
              labelColor: '#666666',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
              fontWeight: '500',
            },
            crossTabCellLabelOptions: {
              labelColorManual: false,
              labelColor: '#666666',
              fontSize: 12,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
              fontWeight: '400',
            },

            labelOptions: {
              showLabel: true,
              showStateLabel: true,
              stateCheckBox: false,
              labelColor: '',
              pieLabel: {
                labelPosition: 'outside',
                labelPadding: 0,
              },
              fontSize: 12,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
            },

            formatOptions: {
              labelFormats: {
                formatValue: 'Number',
                currencySymbol: '$',
                enableRounding: 'false',
                roundingDigits: 1,
                numberSeparator: 'Abbrev',
                selectedMeasure: {},
                // measureFormats will keep the format options for the measure selected in the chart for individual measure
                measureFormats: {},
              },

              yAxisFormats: {
                1: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },

              xAxisFormats: {
                1: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },

              tooltipFormats: {
                isEnable: true,
                formatValue: 'Number',
                currencySymbol: '$',
                enableRounding: 'false',
                roundingDigits: 1,
                numberSeparator: 'Abbrev',
                checkedMeasure: [],
                extraMeasureField: [{ name: 'Measure', fields: [] }],
                extraMeasureFieldsResponses: [],
                selectedMeasure: {},
                measureFormats: {},
              },

              gaugeChartFormats: {
                measureFormat: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: 'false',
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
                labelFormat: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: 'false',
                  roundingDigits: 0,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },
            },

            mouseOver: {
              enable: true,
            },

            smoothCurve: {
              enable: true,
            },

            barLineSettings: {
              lineMeasures: [],
              barMeasures: [],
            },

            layoutOptions: {
              tableLayout: 'shrinked',
              manualWidth: false,
              manualHeight: false,
              customWidth: {},
              customHeight: {},
            },

            axisOptions: {
              xSplitLine: true,
              ySplitLine: true,
              inverse: false,
              gaugeAxisOptions: {
                startAngle: 225,
                endAngle: -45,
                showTick: true,
                tickSize: 5,
                tickPadding: 12,
                showAxisLabel: true,
                labelPadding: 17,
                min: 0,
                max: 0,
                isMaxAuto: true,
              },

              gaugeChartControls: {
                manualColor: false,
                isStepsAuto: true,

                stepcolor: [
                  {
                    color: '#2bb9bb',
                    per: 0.6,
                    isColorAuto: false,
                    stepValue: 60,
                    value: 100,
                  },
                  {
                    color: '#af99db',
                    per: 0.9,
                    isColorAuto: false,
                    stepValue: 30,
                    value: 100,
                  },
                  {
                    color: '#5ab1ef',
                    per: 1,
                    isColorAuto: false,
                    stepValue: 10,
                    value: 100,
                  },
                ],
              },
              pieAxisOptions: {
                pieStartAngle: 90,
                clockWise: true,
              },
              yAxis: {
                1: initializeAxisOptions('y'),
              },
              xAxis: {
                1: initializeAxisOptions('x'),
              },
              scatterChartMinMax: {
                x_enableMin: false,
                x_minValue: 0,
                x_enableMax: false,
                x_maxValue: 10000,
                y_enableMin: false,
                y_minValue: 0,
                y_enableMax: false,
                y_maxValue: 10000,
              },

              axisMinMax: {
                enableMin: false,
                minValue: 0,
                enableMax: false,
                maxValue: 10000,
              },
            },
            tableLabel: [],
            tableGradient: [],
            tableRule: [],

            tableConditionalFormats: [],
            simplecardConditionalFormats: [],
          },
        },
        propList: {
          ...state.propList,
          [action.payload.tabId]: [...state.propList[action.payload.tabId], tileKey],
        },
      };

    case 'ADD_NEW_CONTROL_FROM_TAB':
      let tileKey2 = `${action.payload.tabId}.${action.payload.tileId}`;

      return {
        properties: {
          ...state.properties,
          [tileKey2]: {
            chartErrorDetails: null,
            chartData: '',
            queryResult: '',
            sortOrder: '',
            sortedValue: '',
            sortConfigurations: [],
            measureValue: { value: '', id: 'RichTextID' },
            showHide: {
              operator: '> Greater than',
              numberInput: '',
              dataType: '',
              funcNum: 'Numb',
              showNum: true,
              //Earlier we were storing particular measure name but now we are storing id of that measure in measureName
              measureName: '',
              isShow: true,
            },
            rowSecurity: {
              currentOperator: 'User',
              filterPanels: {
                user: {
                  filters: [],
                  panelName: 'rowLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
                group: {
                  filters: [],
                  panelName: 'rowLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
              },
            },
            columnSecurity: {
              currentOperator: 'User',
              filterPanels: {
                user: {
                  filters: [],
                  panelName: 'columnLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
                group: {
                  filters: [],
                  panelName: 'columnLevelSecurityFilters',
                  shouldAllConditionsMatch: true,
                },
              },
            },
            richText: {
              text: [
                {
                  type: 'p',
                  children: [{ text: 'Enter some text...' }],
                },
              ],
              style: null,
              manualColor: false,
            },
            waterfall: { total: { isEnable: true, isRight: true, name: 'Grand Total' } },
            colorScheme: '',
            themeId: '',
            areaBackgroundColor: '#2BB9BB',
            areaOpacity: 0.1,

            colorScale: {
              colorScaleType: 'Automatic',
              min: 0,
              max: 0,
              minColor: '#2bb9bb',
              maxColor: '#af99db',
              manualColor: false,
            },
            cardControls: {
              height: 200,
              width: 350,
              generateLabelName: 'Auto',
              fontSize: 35,
              subtextFontSize: 15,
              isDragging: false,
              mainTextPos: { x: 129, y: 60 },
              subTextPos: { x: 126, y: 110 },
              subText: '',
              borderTickness: 2,
              borderRadius: 10,
              borderColor: 'rgba(224,224,224,1)',
              dashStyle: 'solid',
              fontStyle: 'normal',
              customStyle: false,
              valueColor: '#2BB9BB',
              labelColor: 'gray',
              bgColor: 'white',
              manualColor: false,
            },

            legendOptions: {
              showLegend: true,
              moveSlider: 'Width',
              symbolWidth: 20,
              symbolHeight: 20,
              itemGap: 10,
              position: { pos: 'Bottom', top: 'bottom', left: 'center' },
              orientation: 'horizontal',
            },

            chartMargin: {
              //for pie
              radius: 70,
              //for gauge
              gaugeRadius: 100,
              // for donut and rose
              innerRadius: 30,
              outerRadius: 70,
              // for funnel chart
              funnelRight: 10,
              funnelLeft: 10,
              // for horizontal charts left
              horizontalLeft: 10,
              // for others
              selectedMargin: 'top',
              top: 5,
              right: 5,
              bottom: 5,
              left: 5,
            },
            wordCloudOptions: {
              shape: 'square',
              rotationMode: 'horizontal',
              gridSize: 8,
              minFontSize: 12,
              maxFontSize: 40,
              drawOutOfBound: false,
              ignoreWords: [],
            },
            calendarStyleOptions: {
              showSplitLine: true,
              splitLineColor: 'black',
              splitLineWidth: 1,
              splitLineType: 'solid',
              showDayLabel: true,
              firstDay: 0,
              dayLabelMargin: 5,
              dayLabelPosition: 'start',
              dayLabelColor: 'black',
              dayLabelFontSize: 10,
              showMonthLabel: true,
              monthLabelMargin: 5,
              monthLabelPosition: 'start',
              monthLabelColor: 'black',
              monthLabelFontSize: 12,
              showYearLabel: true,
              yearLabelMargin: 24,
              yearLabelPosition: 'left',
              yearLabelColor: 'black',
              yearLabelFontSize: 12,
              calendarGap: 30,
              calendarHeight: 10,
              pieceWise: false,
              height: 25,
              width: 80,
              orientation: 'horizontal',
            },

            boxPlotChartControls: {
              colorBy: 'series', // or data,
              minBoxWidth: 10, // px or %,
              maxBoxWidth: 30,
              boxborderWidth: '2', //px
              flipAxis: false,
            },

            geoChartControls: {
              boderWidth: 1,
              borderColor: 'grey',
              mapZoom: 1,
              maxBubbleSize: 25,
              minBubbleSize: 12,
              areaColor: 'rgba(255,255,255,1)',
              emphasisAreaColor: 'yellow',
              aspectScale: 1,
              enableSelfEmphasis: true,
              minValue: '0',
              minColor: '#AF99DB',
              maxValue: '100',
              maxColor: '#2BB9BB',
              showVisualScale: true,
              manualColor: false,
              bgCol: {},
              isDivergentModeEnabled: true,
              isDivergentFormat: 'Abbrev',
              opacity: 70,
              enableBubbleBorder: false,
              bubbleBorderWidth: 2,
              divergentFormatValue: 'Number',
              enableRounding: false,
              roundingDigits: 1,
              currencySymbol: '$',
              percentType: 'NonCalculated',
            },

            treeMapChartControls: {
              treeMapWidth: 80, //%
              treeMapHeight: 80, //%
              leafDepth: 1,
              labelPosition: 'insideTopLeft',
              labelRotate: 0, //dropDown hori,verti,vertiflip
              horizondalAlign: 'right',
              verticleAlign: 'bottom',
              overFlow: 'truncate',
              borderWidth: 0,
              gapWidth: 2,
              showBreadCrumb: true,
              bcHeight: 22,
              bcWidth: 25,
              bcColor: 'rgba(0,0,0,0.7)',
            },

            sankeyControls: {
              nodeWidth: 10,
              nodeGap: 8,
              nodeAlign: 'justify',
              orient: 'horizontal',
              draggable: true,
              labelDistance: 5,
              labelRotate: 0,
              overFlow: 'truncate',

              labelPosition: 'inside',
              opacity: 20,
              curveness: 50,
              nodeColor: '#f589b8',
              linkColor: 'grey',
              nodesAndColors: [],
              backgroundColor: '#fff',
              manualColor: false,
            },

            crossTabStyleOptions: {
              borderWidth: 1,
              lineHeight: 18,
              lineWidth: 80,
              rowHeaderTextAlign: 'left',
              columnHeaderTextAlign: 'center',
              cellTextAlign: 'right',
            },
            crossTabHeaderLabelOptions: {
              labelColorManual: false,
              labelColor: '#666666',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
              fontWeight: '500',
            },
            crossTabCellLabelOptions: {
              labelColorManual: false,
              labelColor: '#666666',
              fontSize: 12,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
              fontWeight: '400',
            },

            labelOptions: {
              showLabel: true,
              showStateLabel: true,
              stateCheckBox: false,
              labelColor: '',
              pieLabel: {
                labelPosition: 'outside',
                labelPadding: 0,
              },
              fontSize: 12,
              fontStyle: 'normal',
              fontWeigth: 'normal',
              fontFamily: 'sans-serif',
            },

            formatOptions: {
              labelFormats: {
                formatValue: 'Number',
                currencySymbol: '$',
                enableRounding: 'false',
                roundingDigits: 1,
                numberSeparator: 'Abbrev',
                selectedMeasure: {},
                // measureFormats will keep the format options for the measure selected in the chart for individual measure
                measureFormats: {},
              },

              yAxisFormats: {
                1: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },

              xAxisFormats: {
                1: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: true,
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },

              tooltipFormats: {
                isEnable: true,
                formatValue: 'Number',
                currencySymbol: '$',
                enableRounding: 'false',
                roundingDigits: 1,
                numberSeparator: 'Abbrev',
                checkedMeasure: [],
                extraMeasureField: [{ name: 'Measure', fields: [] }],
                extraMeasureFieldsResponses: [],
                selectedMeasure: {},
                measureFormats: {},
              },

              gaugeChartFormats: {
                measureFormat: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: 'false',
                  roundingDigits: 1,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
                labelFormat: {
                  formatValue: 'Number',
                  currencySymbol: '$',
                  enableRounding: 'false',
                  roundingDigits: 0,
                  numberSeparator: 'Abbrev',
                  percentageCalculate: false,
                },
              },
            },

            mouseOver: {
              enable: true,
            },

            smoothCurve: {
              enable: true,
            },

            barLineSettings: {
              lineMeasures: [],
              barMeasures: [],
            },

            layoutOptions: {
              tableLayout: 'shrinked',
              manualWidth: false,
              manualHeight: false,
              customWidth: {},
              customHeight: {},
            },

            axisOptions: {
              xSplitLine: true,
              ySplitLine: true,
              inverse: false,
              gaugeAxisOptions: {
                startAngle: 225,
                endAngle: -45,
                showTick: true,
                tickSize: 5,
                tickPadding: 12,
                showAxisLabel: true,
                labelPadding: 17,
                min: 0,
                max: 0,
                isMaxAuto: true,
              },

              gaugeChartControls: {
                manualColor: false,
                isStepsAuto: true,

                stepcolor: [
                  {
                    color: '#2bb9bb',
                    per: 0.6,
                    isColorAuto: false,
                    stepValue: 60,
                    value: 100,
                  },
                  {
                    color: '#af99db',
                    per: 0.9,
                    isColorAuto: false,
                    stepValue: 30,
                    value: 100,
                  },
                  {
                    color: '#5ab1ef',
                    per: 1,
                    isColorAuto: false,
                    stepValue: 10,
                    value: 100,
                  },
                ],
              },
              pieAxisOptions: {
                pieStartAngle: 90,
                clockWise: true,
              },
              yAxis: {
                1: initializeAxisOptions('y'),
              },
              xAxis: {
                1: initializeAxisOptions('x'),
              },
              scatterChartMinMax: {
                x_enableMin: false,
                x_minValue: 0,
                x_enableMax: false,
                x_maxValue: 10000,
                y_enableMin: false,
                y_minValue: 0,
                y_enableMax: false,
                y_maxValue: 10000,
              },

              axisMinMax: {
                enableMin: false,
                minValue: 0,
                enableMax: false,
                maxValue: 10000,
              },
            },
            tableLabel: [],
            tableGradient: [],
            tableRule: [],

            tableConditionalFormats: [],
            simplecardConditionalFormats: [],
          },
        },
        propList: { ...state.propList, [action.payload.tabId]: [tileKey2] },
      };

    case 'DELETE_CONTROLS':
      return update(state, {
        properties: { $unset: [action.payload.propKey] },
        propList: {
          [action.payload.tabId]: { $splice: [[action.payload.tileIndex, 1]] },
        },
      });

    case 'DELETE_CONTROLS_OF_TAB':
      let propsToRemove = state.propList[action.payload];
      return update(state, {
        properties: { $unset: propsToRemove },
        propList: { $unset: [action.payload] },
      });

    // case "SET_NAME_WITH_AGG":
    // 	return update(state, {
    // 		properties: {
    //             [action.payload.propKey]: {
    // 				SetNameWithAgg:{$set:action.payload.SetNameWithAgg},
    // 			},
    //         }
    //     });

    case 'STORE_SERVER_DATA':
      const _propKey = state.properties[action.payload.propKey];
      if (!_propKey) return state;
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            serverData: { $set: action.payload.serverData },
          },
        },
      });

    case 'UPDATE_CHART_DATA':
      const propKey = state.properties[action.payload.propKey];
      if (!propKey) return state;
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartData: { $set: action.payload.chartData },
          },
        },
      });

    case 'SORT_CHART_DATAS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartData: { $set: action.payload.chartData },
          },
        },
      });

    case 'SORT_SERVER_DATAS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            serverData: { $set: action.payload.serverData },
          },
        },
      });

    case 'CALL_QUERY_API':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            callQueryAPI: { $set: action.payload.callQueryAPI },
          },
        },
      });

    case 'SORT_ORDER':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sortOrder: { $set: action.payload.order },
          },
        },
      });

    case 'SORTED_VALUE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sortedValue: { $set: action.payload.value },
          },
        },
      });

    case 'MEASURE_VALUE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              measureName: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SHOW_HIDE_FILTER':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              isShow: { $set: action.payload.isShow },
            },
          },
        },
      });

    case 'UPDATE_CURRENT_OPERATOR':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            rowSecurity: {
              currentOperator: { $set: action.payload.currentOperator },
            },
          },
        },
      });

    case 'UPDATE_CURRENT_OPERATOR_COLUMN':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              currentOperator: { $set: action.payload.currentOperator },
            },
          },
        },
      });

    case 'UPDATE_QUERY_DATA':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            queryResult: { $set: action.payload.query },
          },
        },
      });

    case 'DUPLICATE_CHART_CONTROL':
      Logger('info', 'chartControl' + action.payload.propKey, chartControl);
      return {
        ...state,
        properties: {
          ...state.properties,
          [action.payload.propKey]: action.payload.chartControl,
        },
      };

    case 'STORE_CHART_ERROR_DETAILS': {
      const _propKey = state.properties[action.payload.propKey];
      if (!_propKey) return state;
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartErrorDetails: { $set: action.payload.chartErrorDetails },
          },
        },
      });
    }

    case 'RESET_EXTRA_MEASURE_FIELD': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            formatOptions: {
              tooltipFormats: {
                extraMeasureField: {
                  $set: [{ name: 'Measure', fields: [] }],
                },
              },
            },
          },
        },
      });
    }

    // ########################################
    // Color theme

    case 'CHANGE_COLOR_SCHEME':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            colorScheme: { $set: action.payload.color },
          },
        },
      });

    case 'SET_TILE_THEME_ID':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            themeId: { $set: action.payload.themeId },
          },
        },
      });

    case 'AREA_COLOR_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            [action.payload.option]: { $set: action.payload.value },
          },
        },
      });

    // ########################################
    // Legend

    case 'UPDATE_LEGEND_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            legendOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'RESET_LEGEND_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartMargin: { $set: action.payload.marginValues },
            legendOptions: { $set: action.payload.legendValues },
          },
        },
      });

    // ########################################
    // Margin

    case 'SELECTED_MARGIN':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartMargin: { selectedMargin: { $set: action.payload.margin } },
          },
        },
      });

    case 'UPDATE_CHART_MARGINS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            chartMargin: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    // ########################################
    // MouseOver

    case 'ENABLE_MOUSE_OVER':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            mouseOver: { enable: { $set: action.payload.enable } },
          },
        },
      });

    // ########################################
    // SmoothCurve

    case 'ENABLE_SMOOTH_CURVE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            // smoothCurve: { enable: { $set: action.payload.enable } },
            smoothCurve: {
              // Ensure smoothCurve exists, otherwise create it with enable
              $apply: (smoothCurve = {}) => ({
                ...smoothCurve,
                enable: action.payload.enable,
              }),
            },
          },
        },
      });

    // ########################################
    // Grid & Axis

    case 'ENABLE_GRID':
      switch (action.payload.value) {
        case 'xSplitLine':
        case 'ySplitLine':
          return update(state, {
            properties: {
              [action.payload.propKey]: {
                axisOptions: {
                  [action.payload.value]: { $set: action.payload.show },
                },
              },
            },
          });
        case 'axisBottom':
        case 'axisLeft':
        case 'axisTop':
        case 'axisRight':
          return update(state, {
            properties: {
              [action.payload.propKey]: {
                axisOptions: { selectedAxis: { $set: action.payload.value } },
              },
            },
          });

        default:
          return state;
      }

    case 'AXIS_MIN_MAX':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              axisMinMax: {
                [action.payload.axisKey]: { $set: action.payload.axisValue },
              },
            },
          },
        },
      });

    case 'AXIS_MIN_MAX_FOR_SCATTER': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              scatterChartMinMax: {
                $merge: {
                  [action.payload.axisKey]: action.payload.axisValue,
                },
              },
            },
          },
        },
      });
    }

    case 'SET_COLOR_SCALE_OPTION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            colorScale: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'LOAD_CHART_CONTROLS':
      return action.payload;

    case 'RESET_CHART_CONTROLS':
      return chartControl;

    case 'UPDATE_CROSSTAB_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            crossTabStyleOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_CROSSTAB_HEADER_LABEL_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            crossTabHeaderLabelOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_CROSSTAB_CELL_LABEL_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            crossTabCellLabelOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_LAYOUT_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            layoutOptions: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_LABEL_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            labelOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_STATE_LABEL_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            labelOptions: {
              [action.payload.option]: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_FORMAT_OPTIONS':
      const formatType = action.payload.formatType;
      if (formatType === 'yAxisFormats' || formatType === 'xAxisFormats') {
        return update(state, {
          properties: {
            [action.payload.propKey]: {
              formatOptions: {
                [formatType]: {
                  [action.payload.series]: {
                    [action.payload.option]: { $set: action.payload.value },
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            formatOptions: {
              [formatType]: {
                [action.payload.option]: { $set: action.payload.value },
              },
            },
          },
        },
      });

    case 'UPDATE_LABEL_POSITION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            labelOptions: {
              pieLabel: { labelPosition: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'UPDATE_LABEL_PADDING':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            labelOptions: {
              pieLabel: { labelPadding: { $set: action.payload.value } },
            },
          },
        },
      });
    case 'UPDATE_REVERSE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: { inverse: { $set: action.payload.value } },
          },
        },
      });
    case 'UPDATE_PIE_AXIS_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              pieAxisOptions: {
                [action.payload.option]: { $set: action.payload.value },
              },
            },
          },
        },
      });

    case 'UPDATE_AXIS_OPTIONS':
      if (action.payload.axis === 'yAxis' || action.payload.axis === 'xAxis') {
        return update(state, {
          properties: {
            [action.payload.propKey]: {
              axisOptions: {
                [action.payload.axis]: {
                  [action.payload.series]: {
                    [action.payload.option]: {
                      $set: action.payload.value,
                    },
                  },
                },
              },
            },
          },
        });
      }
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              [action.payload.axis]: {
                [action.payload.option]: {
                  $set: action.payload.value,
                },
              },
            },
          },
        },
      });
    case 'UPDATE_GAUGE_AXIS_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              gaugeAxisOptions: {
                [action.payload.option]: {
                  $set: action.payload.value,
                },
              },
            },
          },
        },
      });
    case 'ADDING_NEW_STEP':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              gaugeChartControls: {
                stepcolor: {
                  $splice: [[action.payload.index, 0, action.payload.value]],
                },
              },
            },
          },
        },
      });

    case 'CHANGING_VALUES_OF_STEPS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              gaugeChartControls: {
                stepcolor: { $set: action.payload.value },
              },
            },
          },
        },
      });
    case 'SWITCH_STEPS_AUTO_MANUAL':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              gaugeChartControls: {
                isStepsAuto: { $set: action.payload.value },
              },
            },
          },
        },
      });
    case 'CHANGING_MANUAL_COLOR_GAUGE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            axisOptions: {
              gaugeChartControls: {
                manualColor: { $set: action.payload.value },
              },
            },
          },
        },
      });
    case 'UPDATE_CALENDER_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            calendarStyleOptions: {
              [action.payload.option]: {
                $set: action.payload.value,
              },
            },
          },
        },
      });

    // case 'UPDATE_WORD_CLOUD_OPTIONS':
    //   return {
    //     ...state,
    //     properties: {
    //       ...state.properties,
    //       [action.payload.propKey]: {
    //         ...state.properties[action.payload.propKey],
    //         wordCloudOptions: {
    //           ...(state.properties[action.payload.propKey].wordCloudOptions || {}),
    //           [action.payload.option]: action.payload.value,
    //         },
    //       },
    //     },
    //   };
    case 'UPDATE_WORD_CLOUD_OPTIONS': {
      const { propKey, option, value } = action.payload;
      if (!propKey || !option || value === undefined || value === null) return state;

      return update(state, {
        properties: {
          [propKey]: {
            wordCloudOptions: {
              $apply: (wc = {}) => ({
                ...wc,
                [option]: value,
              }),
            },
          },
        },
      });
    }

    case 'UPDATE_BOXPLOT_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            boxPlotChartControls: {
              [action.payload.option]: {
                $set: action.payload.value,
              },
            },
          },
        },
      });

    case 'UPDATE_GEOCHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            geoChartControls: {
              [action.payload.option]: {
                $set: action.payload.value,
              },
            },
          },
        },
      });

    case 'UPDATE_TREEMAP_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            treeMapChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_SANKEY_STYLE_OPTIONS': // Updated to match the safer pattern
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sankeyControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_PIE_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            pieChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_DOUGH_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            doughnutChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_ROSE_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            roseChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_LINE_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            lineChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_AREA_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            areaChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_STACKED_AREA_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            stackedAreaChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_SCATTER_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            scatterPlotChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_FUNNEL_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            funnelChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_BAR_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            barChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_HORIZONTAL_BAR_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            horizontalBarChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_STACKED_BAR_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            stackedBarChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });

    case 'UPDATE_HORIZONTAL_STACKED_BAR_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            horizontalStackedBarChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });
    case 'UPDATE_WATERFALL_CHART_STYLE_OPTIONS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            waterfallChartControls: {
              $apply: (controls = {}) => ({
                ...controls,
                [action.payload.option]: action.payload.value,
              }),
            },
          },
        },
      });
    case 'UPDATE_RICH_TEXT':
      let _richText = { text: action.payload.value, style: null };
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            richText: {
              $set: _richText,
            },
          },
        },
      });

    case 'UPDATE_RICH_TEXT_MANUAL_COLOR':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            richText: {
              manualColor: { $set: action.payload.value },
            },
          },
        },
      });

    case 'UPDATE_RICH_TEXT_DYNAMIC_VALUE':
      const richText = state.properties[action.payload.propKey]?.richText;
      const text = richText?.text;
      const children = text?.[0]?.children;

      if (children && children[1]?.character !== undefined) {
        // If richText.text[0].children[1].character exists, update it
        return update(state, {
          properties: {
            [action.payload.propKey]: {
              richText: {
                text: {
                  0: {
                    children: {
                      1: {
                        character: { $set: action.payload.value },
                      },
                    },
                  },
                },
              },
            },
          },
        });
      } else return state; // Or some other fallback logic

    case 'UPDATE_CARD_CONTROLS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            cardControls: {
              [action.payload.option]: {
                $set: action.payload.value,
              },
            },
          },
        },
      });

    case 'UPDATE_RICH_TEXT_ON_ADDING_DYNAMIC_MEASURE':
      let measureText = {};

      if (action.payload.value) {
        measureText = {
          text: action.payload.dmValue,
          style: action.payload.style,
        };
      } else if (false) {
        //measureText = removeTagFromHTMLString(state.properties[action.payload.propKey].richText, 'label', "RichTextID" + action.payload.dmId);

        //if(!action.payload?.dmId?.toString()?.includes("RichTextID")){
        measureText = { text: '', style: '' };

        let _richText = JSON.parse(
          JSON.stringify(state.properties[action.payload.propKey].richText),
        );

        _richText?.text?.forEach((list: any) => {
          let index = list.children.findIndex((item: any) => {
            if (action.payload.dmId?.toString().includes('RichTextID')) {
              return item.id === action.payload.dmId;
            } else {
              return item.id === 'RichTextID' + action.payload.dmId;
            }
          });

          if (index > -1) {
            list.children.splice(index, 1);
            return;
          }
        });

        return update(state, {
          properties: {
            [action.payload.propKey]: {
              richText: {
                $set: _richText,
              },
            },
          },
        });
        // }
        // else{
        // 	measureText = {text: action.payload.dmValue, style:  action.payload.style};

        // 	return update(state, {
        // 		properties: {
        // 			[action.payload.propKey]: {
        // 				richText: {
        // 					$set: measureText
        // 				},
        // 			},
        // 		},
        // 	});
        // }
      }

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            measureValue: {
              $set: {
                value: measureText,
                id: 'RichTextID' + action.payload.dmId,
              },
            },
          },
        },
      });

    case 'CLEAR_RICH_TEXT':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            measureValue: {
              $set: { value: '', id: '' },
            },
          },
        },
      });
    case 'ADD_TABLE_CONDITIONAL_FORMATS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              $push: [action.payload.item],
            },
          },
        },
      });

    case 'INVALIDATE_CONDITIONAL_FORMAT': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              $set: action.payload.item,
            },
          },
        },
      });
    }

    case 'UPDATE_CONDITIONAL_FORMAT_NAME':
      if (!action.payload.propKey || action.payload.index < 0 || !action.payload.name) return state;
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              [action.payload.index]: {
                name: { $set: action.payload.name },
              },
            },
          },
        },
      });

    case 'DELETE_TABLE_CONDITIONAL_FORMATS':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              $splice: [[action.payload.index, 1]],
            },
          },
        },
      });

    case 'UPDATE_CF_OBJECT1': //CF referse to conditional format
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              [action.payload.index]: { $set: action.payload.item },
            },
          },
        },
      });

    case 'UPDATE_RULE_OBJECT':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              [action.payload.ObjectIndex]: {
                value: {
                  [action.payload.itemIndex]: { $set: action.payload.item },
                },
              },
            },
          },
        },
      });
    /// new code
    case 'ADD_TABLE_LABEL':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableLabel: {
              $push: [action.payload.item],
            },
          },
        },
      });
    case 'UPDATE_CF_OBJECT': //CF referse to conditional format
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            tableConditionalFormats: {
              $set: action.payload.item,
            },
          },
        },
      });
    case 'ADD_OR_EDIT_SIMPLECARD_CF': //CF referse to conditional format
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            simplecardConditionalFormats: {
              $set: action.payload.item,
            },
          },
        },
      });

    case 'UPDATE_SHOW_HIDE_OPERATOR_VALUE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              operator: { $set: action.payload.value },
            },
          },
        },
      });
    case 'UPDATE_SHOW_HIDE_NUMBER_INPUT_VALUE':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              numberInput: { $set: action.payload.value },
              dataType: { $set: action.payload.dataType },
            },
          },
        },
      });
    case 'UPDATE_FUNC_NUM':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              funcNum: { $set: action.payload.value },
            },
          },
        },
      });

    case 'SET_SHOW_NUM':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            showHide: {
              showNum: { $set: action.payload.value },
            },
          },
        },
      });

    case 'ENABLE_DISABLE_TOTAL_SWITCH':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            waterfall: {
              total: {
                isEnable: {
                  $set: action.payload.isEnable,
                },
              },
            },
          },
        },
      });

    case 'CHANGE_TOTAL_BAR_POSITION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            waterfall: {
              total: {
                isRight: {
                  $set: action.payload.isRight,
                },
              },
            },
          },
        },
      });

    case 'RENAME_GRAND_TOTAL':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            waterfall: {
              total: {
                name: {
                  $set: action.payload.newName,
                },
              },
            },
          },
        },
      });

    case 'UPDATE_ROW_SECURITY_FILTERS': {
      const filterData = action.payload.filterData;

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            rowSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    $set: [
                      {
                        dataType: filterData.dataType,
                        displayName: filterData.displayName,
                        fieldName: filterData.fieldName,
                        source: filterData.source,
                        sourceType: filterData.sourceType,
                        tableId: filterData.tableId,
                        userSelection: filterData.userSelection,
                        calculationUUID: filterData.calculationUUID,
                        currentSelection: filterData.currentSelection,
                        filterId: filterData.filterId,
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'UPDATE_USER_SELECTION': {
      if (
        !state.properties[action.payload.propKey]?.rowSecurity?.filterPanels?.[
          action.payload.operator
        ]?.filters?.[0]
      ) {
        return state;
      }

      const rawSelection = action.payload.email;
      const userSelection =
        Array.isArray(rawSelection) && rawSelection[0] === null ? [] : rawSelection;

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            rowSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    0: {
                      userSelection: { $set: userSelection },
                    },
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'REMOVE_ROW_SECURITY_CARD': {
      const filterPanel =
        state.properties[action.payload.propKey].rowSecurity.filterPanels[action.payload.operator];
      const filters = filterPanel.filters;

      // Find index of filter where source matches id
      const targetIndex = filters.findIndex((filter: any) => filter.source === action.payload.id);

      if (targetIndex === -1) return state; // ID not found, no change

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            rowSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    $splice: [[targetIndex, 1]],
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'REMOVE_ROW_SECURITY_FILTERS': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            rowSecurity: {
              $set: {
                currentOperator: 'User',
                filterPanels: {
                  user: {
                    filters: [],
                    panelName: 'rowLevelSecurityFilters',
                    shouldAllConditionsMatch: true,
                  },
                  group: {
                    filters: [],
                    panelName: 'rowLevelSecurityFilters',
                    shouldAllConditionsMatch: true,
                  },
                },
              },
            },
          },
        },
      });
    }

    // case 'UPDATE_COLUMN_SECURITY_FILTERS': {
    //   const filterData = action.payload.filterData;

    //   return update(state, {
    //     properties: {
    //       [action.payload.propKey]: {
    //         columnSecurity: {
    //           filterPanels: {
    //             [action.payload.operator]: {
    //               filters: {
    //                 0:
    //                   {
    //                     dataType: filterData.dataType,
    //                     displayName: filterData.displayName,
    //                     fieldName: filterData.fieldName,
    //                     source: filterData.source,
    //                     sourceType: filterData.sourceType,
    //                     tableId: filterData.tableId,
    //                     userSelection: filterData.userSelection,
    //                     currentSelection: filterData.currentSelection,
    //                     filterId: filterData.filterId,
    //                     mapping: filterData.mapping,
    //                     measureDropFields: filterData.measureDropFields,
    //                   },
    //               },
    //             },
    //           },
    //         },
    //       },
    //     },
    //   });
    // }

    case 'UPDATE_COLUMN_SECURITY_FILTERS': {
      const filterData = action.payload.filterData;

      const newFilter = {
        dataType: filterData.dataType,
        displayName: filterData.displayName,
        fieldName: filterData.fieldName,
        filterType: filterData.filterType,
        operator: filterData.operator || 'in',
        shouldExclude: filterData.shouldExclude || false,
        tableId: filterData.tableId,
        userSelection: filterData.userSelection,
        calculationUUID: filterData.calculationUUID,
        currentSelection: filterData.currentSelection,
        filterId: filterData.filterId,
        // measureDropFields: filterData.measureDropFields,
      };

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    0: { $set: newFilter },
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'UPDATE_USER_SELECTION_COLUMN': {
      if (
        !state.properties[action.payload.propKey]?.columnSecurity?.filterPanels?.[
          action.payload.operator
        ]?.filters?.[0]
      ) {
        return state;
      }

      const rawSelection = action.payload.email;
      const userSelection =
        Array.isArray(rawSelection) && rawSelection[0] === null ? [] : rawSelection;

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    0: {
                      userSelection: { $set: userSelection },
                    },
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'UPDATE_MEASURE_MAPPING_COLUMN': {
      const {
        propKey,
        operator,
        mapping,
      }: {
        propKey: string;
        operator: string;
        mapping: Record<string, string>[];
      } = action.payload;

      const existingMappings: Record<string, string>[] =
        state.properties?.[propKey]?.columnSecurity?.filterPanels?.[operator]?.filters?.[1]
          ?.mapping || [];

      const existingMap = new Map<string, { index: number; item: Record<string, string> }>();
      existingMappings.forEach((item: Record<string, string>, index: number) => {
        const key: string | undefined = Object.keys(item)[0];
        if (key) {
          existingMap.set(key, { index, item });
        }
      });

      // Process the incoming mapping array
      const updatedMappings: Record<string, string>[] = [...existingMappings];
      const newMappings: Record<string, string>[] = [];

      mapping.forEach((item: Record<string, string>) => {
        // Get the key from the mapping item
        const itemKey: string | undefined = Object.keys(item)[0];

        if (itemKey && existingMap.has(itemKey)) {
          // Update existing mapping
          const existingItem = existingMap.get(itemKey);
          if (existingItem) {
            const { index } = existingItem;
            updatedMappings[index] = item;
          }
        } else {
          // Add to new mappings
          newMappings.push(item);
        }
      });

      const finalMappings: Record<string, string>[] = [...updatedMappings, ...newMappings];

      const updatedState = update(state, {
        properties: {
          [propKey]: {
            columnSecurity: {
              filterPanels: {
                [operator]: {
                  filters: {
                    1: {
                      mapping: { $set: finalMappings },
                    },
                  },
                },
              },
            },
          },
        },
      });

      return updatedState;
    }

    case 'REMOVE_MEASURE_MAPPING_COLUMN': {
      const filterPanel =
        state.properties[action.payload.propKey].columnSecurity.filterPanels[
          action.payload.operator
        ];

      const mappings = filterPanel.filters[1]?.mapping || [];

      const targetIndex = mappings.findIndex((mapObj: any) =>
        Object.keys(mapObj).includes(action.payload.id),
      );

      if (targetIndex === -1) return state; // ID not found, no change

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    1: {
                      mapping: {
                        $splice: [[targetIndex, 1]],
                      },
                    },
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'UPDATE_MEASURE_DROP_FILTERS': {
      const filterData = action.payload.filterData;

      const newFilter = {
        dataType: filterData.dataType,
        displayName: filterData.displayName,
        fieldName: filterData.fieldName,
        source: filterData.source,
        sourceType: filterData.sourceType,
        filterType: filterData.filterType,
        tableId: filterData.tableId,
        aggr: filterData.agg,
        mapping: filterData.mapping,
        userSelection: filterData.userSelection,
        calculationUUID: filterData.calculationUUID,
      };

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    1: { $set: newFilter },
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'REMOVE_COLUMN_SECURITY_CARD': {
      // const filterPanel =
      //   state.properties[action.payload.propKey].columnSecurity.filterPanels[
      //     action.payload.operator
      //   ];
      // const filters = filterPanel.filters;

      // // Find index of filter where source matches id
      // const targetIndex = filters.findIndex((filter: any) => filter.source === action.payload.id);

      // if (targetIndex === -1) return state; // ID not found, no change

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    $set: [],
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'REMOVE_MEASURE_FIELD_CARD': {
      // const filterPanel =
      //   state.properties[action.payload.propKey].columnSecurity.filterPanels[
      //     action.payload.operator
      //   ];
      // const filters = filterPanel.filters[1];

      // console.log('filters', filters);

      // console.log('action.payload.id', action.payload.id);

      // console.log('filters.findIndex', filters.findIndex((filter: any) => filter.source === action.payload.id));

      // // Find index of filter where source matches id
      // const targetIndex = filters.findIndex((filter: any) => filter.source === action.payload.id);

      // if (targetIndex === -1) return state; // ID not found, no change

      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              filterPanels: {
                [action.payload.operator]: {
                  filters: {
                    $splice: [[1, 1]],
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'REMOVE_COLUMN_SECURITY_FILTERS': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            columnSecurity: {
              $set: {
                currentOperator: 'User',
                filterPanels: {
                  user: {
                    filters: [],
                    panelName: 'columnLevelSecurityFilters',
                    shouldAllConditionsMatch: true,
                  },
                  group: {
                    filters: [],
                    panelName: 'columnLevelSecurityFilters',
                    shouldAllConditionsMatch: true,
                  },
                },
              },
            },
          },
        },
      });
    }

    case 'INITIALIZE_WATERFALL_STATE':
      if (!state.properties[action.payload.propKey].waterfall) {
        return update(state, {
          properties: {
            [action.payload.propKey]: {
              waterfall: {
                $set: {
                  total: {
                    isEnable: true,
                    isRight: true,
                    name: 'Grand Total',
                  },
                },
              },
            },
          },
        });
      }
      return state;

    case 'ENABLE_DISABLE_TOOLTIP_SWITCH':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            formatOptions: {
              tooltipFormats: {
                isEnable: {
                  $set: action.payload.isEnable,
                },
              },
            },
          },
        },
      });

    case 'INITIALIZE_TOOLTIP_FORMAT_STATE':
      if (!state.properties[action.payload.propKey].formatOptions.tooltipFormats) {
        return update(state, {
          properties: {
            [action.payload.propKey]: {
              formatOptions: {
                tooltipFormats: {
                  $set: {
                    isEnable: true,
                    formatValue: 'Number',
                    currencySymbol: '$',
                    enableRounding: 'false',
                    roundingDigits: 1,
                    numberSeparator: 'Abbrev',
                    checkedMeasure: [],
                    extraMeasureField: [{ name: 'Measure', fields: [] }],
                    extraMeasureFieldsResponses: [],
                    selectedMeasure: {},
                    measureFormats: {},
                  },
                },
              },
            },
          },
        });
      }
      return state;

    case 'UPDATE_EXTRA_MEASURE_FIELD': {
      const { propKey, binIndex, itemIndex, item } = action.payload;
      const extraMeasureField =
        state.properties[propKey].formatOptions.tooltipFormats.extraMeasureField;
      const updatedFields = [...extraMeasureField[binIndex].fields];
      updatedFields[itemIndex] = item;

      const updatedExtraMeasureField = [...extraMeasureField];
      updatedExtraMeasureField[binIndex] = {
        ...updatedExtraMeasureField[binIndex],
        fields: updatedFields,
      };

      return update(state, {
        properties: {
          [propKey]: {
            formatOptions: {
              tooltipFormats: {
                extraMeasureField: { $set: updatedExtraMeasureField },
              },
            },
          },
        },
      });
    }

    case 'ENABLE_OVERRIDE_FOR_EXTRA_MEASURE': {
      const { propKey, uId } = action.payload;
      return update(state, {
        properties: {
          [propKey]: {
            formatOptions: {
              tooltipFormats: {
                enableOverrideForExtraMeasureUID: { $set: uId },
              },
            },
          },
        },
      });
    }

    case 'TOGGLE_MEASURE_AS_LINE': {
      const { propKey, measureUidList } = action.payload;
      return update(state, {
        properties: {
          [propKey]: {
            barLineSettings: {
              lineMeasures: { $set: measureUidList },
            },
          },
        },
      });
    }

    case 'TOGGLE_MEASURE_AS_BAR': {
      const { propKey, measureUidList } = action.payload;
      return update(state, {
        properties: {
          [propKey]: {
            barLineSettings: {
              barMeasures: { $set: measureUidList },
            },
          },
        },
      });
    }

    case 'UPDATE_SERIES': {
      const { propKey, seriesName, operation, axisType } = action.payload;
      if (operation === 'add') {
        if (axisType === 'x') {
          return update(state, {
            properties: {
              [propKey]: {
                axisOptions: {
                  xAxis: {
                    [seriesName]: {
                      $set: initializeAxisOptions('x'),
                    },
                  },
                },
                formatOptions: {
                  yAxisFormats: {
                    [seriesName]: {
                      $set: {
                        formatValue: 'Number',
                        currencySymbol: '$',
                        enableRounding: true,
                        roundingDigits: 1,
                        numberSeparator: 'Abbrev',
                        percentageCalculate: false,
                      },
                    },
                  },
                },
              },
            },
          });
        }
        return update(state, {
          properties: {
            [propKey]: {
              axisOptions: {
                yAxis: {
                  [seriesName]: {
                    $set: initializeAxisOptions('y'),
                  },
                },
              },
              formatOptions: {
                yAxisFormats: {
                  [seriesName]: {
                    $set: {
                      formatValue: 'Number',
                      currencySymbol: '$',
                      enableRounding: true,
                      roundingDigits: 1,
                      numberSeparator: 'Abbrev',
                      percentageCalculate: false,
                    },
                  },
                },
              },
            },
          },
        });
      } else {
        // operation === 'remove'
        if (axisType === 'x') {
          return update(state, {
            properties: {
              [propKey]: {
                axisOptions: {
                  xAxis: {
                    $unset: [seriesName],
                  },
                },
                formatOptions: {
                  yAxisFormats: {
                    $unset: [seriesName],
                  },
                },
              },
            },
          });
        }
        return update(state, {
          properties: {
            [propKey]: {
              axisOptions: {
                yAxis: {
                  $unset: [seriesName],
                },
              },
              formatOptions: {
                yAxisFormats: {
                  $unset: [seriesName],
                },
              },
            },
          },
        });
      }
    }

    case 'ADD_SORT_CONFIGURATION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sortConfigurations: { $push: [action.payload.sortConfig] },
          },
        },
      });

    case 'UPDATE_SORT_CONFIGURATION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sortConfigurations: {
              [action.payload.index]: { $set: action.payload.sortConfig },
            },
          },
        },
      });

    case 'DELETE_SORT_CONFIGURATION':
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            sortConfigurations: { $splice: [[action.payload.index, 1]] },
          },
        },
      });

    case 'INITIALIZE_GAUGE_CHART_FORMATS': {
      return update(state, {
        properties: {
          [action.payload.propKey]: {
            formatOptions: {
              gaugeChartFormats: {
                $set: {
                  measureFormat: {
                    formatValue: 'Number',
                    currencySymbol: '$',
                    enableRounding: 'false',
                    roundingDigits: 1,
                    numberSeparator: 'Abbrev',
                    percentageCalculate: false,
                  },
                  labelFormat: {
                    formatValue: 'Number',
                    currencySymbol: '$',
                    enableRounding: 'false',
                    roundingDigits: 0,
                    numberSeparator: 'Abbrev',
                    percentageCalculate: false,
                  },
                },
              },
            },
          },
        },
      });
    }

    default:
      return state;
  }
};

export default chartControlsReducer;
